/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fair_Soft_Mouse_BaskInputs */

const en_fair_soft_mouse_bask = /** @type {(inputs: Fair_Soft_Mouse_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No segments available`)
};

const de_fair_soft_mouse_bask = /** @type {(inputs: Fair_Soft_Mouse_BaskInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es sind keine Segmente verfügbar`)
};

/**
* | output |
* | --- |
* | "No segments available" |
*
* @param {Fair_Soft_Mouse_BaskInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fair_soft_mouse_bask = /** @type {((inputs?: Fair_Soft_Mouse_BaskInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fair_Soft_Mouse_BaskInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_fair_soft_mouse_bask(inputs)
	return de_fair_soft_mouse_bask(inputs)
});